import { render } from "./AuthorName.vue?vue&type=template&id=9cec6250"
import script from "./AuthorName.vue?vue&type=script&lang=js"
export * from "./AuthorName.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__